import { QdzElement, define } from '@qdz/element';

const TARGETS = {
  menu: 'qdz-dialog[id^="qdz-menu-drawer-"]',
  filters: 'qdz-dialog[id^="qdz-facets-"]',
  search: 'qdz-dialog#qdz-search',
};

export class QdzBottomNav extends QdzElement {
  mount() {
    this.listen(this, 'click', (event) => {
      const link = event.target.closest('[data-qdz-open]');
      if (link && this.contains(link)) this.#open(event, link);
    });
    this.listen(document, 'qdz:cart:updated', (event) => {
      const count = event.detail?.cart?.item_count;
      if (typeof count !== 'number') return;
      for (const badge of this.querySelectorAll('[data-qdz-cart-badge]')) {
        badge.textContent = count;
        badge.hidden = count === 0;
      }
    });
  }

  #open(event, link) {
    const type = link.dataset.qdzOpen;
    const dialog = document.querySelector(TARGETS[type]);
    if (dialog && typeof dialog.open === 'function') {
      event.preventDefault();
      dialog.open(link);
      return;
    }
    if (type !== 'search') return;
    const field = document.querySelector('.qdz-header-search__input');
    if (!field || !field.offsetParent) return;
    event.preventDefault();
    field.scrollIntoView({ block: 'center' });
    field.focus();
  }
}

define('qdz-bottom-nav', QdzBottomNav);
